if (!customElements.get('ccc-product-rail')) {
  customElements.define('ccc-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-ccc-rail]');
      this.controls = this.querySelector('[data-ccc-rail-controls]');
      this.previous = this.querySelector('[data-ccc-rail-prev]');
      this.next = this.querySelector('[data-ccc-rail-next]');
      if (!this.rail || !this.previous || !this.next) return;

      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.rail.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.rail);
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    move(direction) {
      const firstCard = this.rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : this.rail.clientWidth * 0.8;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.rail.scrollBy({ left: distance * direction, behavior });
    }

    update() {
      const hasOverflow = this.rail.scrollWidth > this.rail.clientWidth + 4;
      this.controls.hidden = !hasOverflow;
      this.previous.disabled = !hasOverflow || this.rail.scrollLeft <= 4;
      this.next.disabled = !hasOverflow || this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 4;
    }
  });
}

if (!window.cccInstafeedRailInitialized) {
  window.cccInstafeedRailInitialized = true;

  const connectInstafeedRail = () => {
    const rail = document.querySelector('#insta-feed');
    const previous = document.querySelector('[data-ccc-instafeed-prev]');
    const next = document.querySelector('[data-ccc-instafeed-next]');
    const toggle = document.querySelector('[data-ccc-instafeed-toggle]');
    const toggleIcon = toggle?.querySelector('[data-ccc-instafeed-toggle-icon]');
    const firstCard = rail?.querySelector('.instafeed-new-layout-item');
    if (!rail || !previous || !next || !toggle || !toggleIcon || !firstCard || rail.dataset.cccRailConnected === 'true') return false;

    rail.dataset.cccRailConnected = 'true';
    rail.setAttribute('tabindex', '0');
    rail.setAttribute('aria-label', 'Customer creations from Instagram');

    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = reducedMotion.matches;
    let interactionPaused = false;
    let autoTimer;
    let hasOverflow = false;

    const stopAutoScroll = () => {
      clearTimeout(autoTimer);
    };

    const updateToggle = () => {
      toggle.dataset.state = userPaused ? 'paused' : 'playing';
      toggleIcon.textContent = userPaused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', userPaused ? 'Play automatic customer gallery' : 'Pause automatic customer gallery');
      toggle.title = toggle.getAttribute('aria-label');
    };

    const getDistance = () => {
      const card = rail.querySelector('.instafeed-new-layout-item');
      const wrapper = rail.querySelector('.instafeed-new-layout-wrapper');
      const gap = wrapper ? parseFloat(getComputedStyle(wrapper).columnGap) || 0 : 0;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    };

    const move = (direction, automatic = false) => {
      const behavior = reducedMotion.matches && !automatic ? 'auto' : 'smooth';
      rail.scrollBy({ left: getDistance() * direction, behavior });
    };

    const scheduleAutoScroll = () => {
      stopAutoScroll();
      const instafeedPopupOpen = document.body.classList.contains('instafeed-body-no-scroll');
      if (userPaused || interactionPaused || instafeedPopupOpen || document.hidden || !hasOverflow) return;
      autoTimer = setTimeout(() => {
        if (document.body.classList.contains('instafeed-body-no-scroll')) {
          scheduleAutoScroll();
          return;
        }
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
        if (atEnd) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          move(1, true);
        }
        scheduleAutoScroll();
      }, 4200);
    };

    const update = () => {
      hasOverflow = rail.scrollWidth > rail.clientWidth + 4;
      previous.disabled = !hasOverflow || rail.scrollLeft <= 4;
      next.disabled = !hasOverflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      toggle.disabled = !hasOverflow;
    };

    const setInteractionPaused = (paused) => {
      interactionPaused = paused;
      updateToggle();
      scheduleAutoScroll();
    };

    previous.addEventListener('click', () => {
      move(-1);
      scheduleAutoScroll();
    });
    next.addEventListener('click', () => {
      move(1);
      scheduleAutoScroll();
    });
    toggle.addEventListener('click', () => {
      userPaused = !userPaused;
      updateToggle();
      scheduleAutoScroll();
    });
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('pointerenter', () => setInteractionPaused(true));
    rail.addEventListener('pointerleave', () => setInteractionPaused(false));
    rail.addEventListener('focusin', () => setInteractionPaused(true));
    rail.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!rail.contains(document.activeElement)) setInteractionPaused(false);
      });
    });
    document.addEventListener('visibilitychange', scheduleAutoScroll);
    new MutationObserver(scheduleAutoScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) userPaused = true;
      updateToggle();
      scheduleAutoScroll();
    });
    new ResizeObserver(() => {
      update();
      scheduleAutoScroll();
    }).observe(rail);
    update();
    updateToggle();
    scheduleAutoScroll();
    return true;
  };

  if (!connectInstafeedRail()) {
    const observer = new MutationObserver(() => {
      if (connectInstafeedRail()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}

if (!window.cccOccasionRotatorsInitialized) {
  window.cccOccasionRotatorsInitialized = true;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-ccc-occasion-rotator]').forEach((rotator) => {
    const toggle = rotator.querySelector('[data-ccc-occasion-toggle]');
    const toggleIcon = toggle?.querySelector('[data-ccc-occasion-toggle-icon]');
    const grid = rotator.querySelector('.ccc-occasion-grid');
    const hasMultipleFrames = !!rotator.querySelector('[data-frame-count="2"], [data-frame-count="3"]');
    if (!toggle || !toggleIcon || !grid || !hasMultipleFrames) {
      if (toggle) toggle.hidden = true;
      return;
    }

    let userPaused = reducedMotion.matches;
    let interactionPaused = false;

    const update = () => {
      rotator.dataset.rotationPaused = userPaused || interactionPaused ? 'true' : 'false';
      toggle.dataset.state = userPaused ? 'paused' : 'playing';
      toggleIcon.textContent = userPaused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', userPaused ? 'Play changing collection designs' : 'Pause changing collection designs');
      toggle.title = toggle.getAttribute('aria-label');
    };

    toggle.addEventListener('click', () => {
      userPaused = !userPaused;
      update();
    });
    grid.addEventListener('pointerenter', () => {
      interactionPaused = true;
      update();
    });
    grid.addEventListener('pointerleave', () => {
      interactionPaused = false;
      update();
    });
    grid.addEventListener('focusin', () => {
      interactionPaused = true;
      update();
    });
    grid.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!grid.contains(document.activeElement)) {
          interactionPaused = false;
          update();
        }
      });
    });
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) userPaused = true;
      update();
    });
    update();
  });
}

/* The former hand-built Google embed opened with a blank place card. Keep the
 * useful Google directions link in the page copy and give the inline map a
 * deterministic, popup-free OpenStreetMap view. */
document.querySelectorAll('.ccc-visit-map iframe').forEach((map) => {
  if (!map.src.includes('google.com/maps/embed')) return;
  map.src = 'https://www.openstreetmap.org/export/embed.html?bbox=146.3848265%2C-38.2408386%2C146.3968265%2C-38.2308386&layer=mapnik&marker=-38.2358386%2C146.3908265';
  map.removeAttribute('allowfullscreen');
});

if (!window.cccHeroShowcasesInitialized) {
  window.cccHeroShowcasesInitialized = true;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-ccc-hero-showcase]').forEach((showcase) => {
    const slides = [...showcase.querySelectorAll('[data-ccc-hero-slide]')];
    const previous = showcase.querySelector('[data-ccc-hero-prev]');
    const next = showcase.querySelector('[data-ccc-hero-next]');
    const toggle = showcase.querySelector('[data-ccc-hero-toggle]');
    const toggleIcon = toggle?.querySelector('[data-ccc-hero-toggle-icon]');
    const status = showcase.querySelector('[data-ccc-hero-status]');
    const hero = showcase.closest('.ccc-hero');
    const controls = showcase.querySelector('.ccc-hero-showcase__controls');

    if (!slides.length || !previous || !next || !toggle || !toggleIcon || !hero) return;

    if (slides.length < 2) {
      if (controls) controls.hidden = true;
      slides[0].dataset.state = 'active';
      slides[0].removeAttribute('aria-hidden');
      slides[0].removeAttribute('inert');
      slides[0].removeAttribute('tabindex');
      return;
    }

    let index = 0;
    let userPaused = reducedMotion.matches;
    let interactionPaused = false;
    let inView = true;
    let timer;

    const stop = () => clearTimeout(timer);

    const isPaused = () => userPaused || interactionPaused || !inView || document.hidden;

    const updatePauseState = () => {
      hero.dataset.showcasePaused = isPaused() ? 'true' : 'false';
      toggle.dataset.state = userPaused ? 'paused' : 'playing';
      toggleIcon.textContent = userPaused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', userPaused ? 'Play featured designs' : 'Pause featured designs');
      toggle.title = toggle.getAttribute('aria-label');
    };

    const render = (nextIndex, manual = false) => {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const distance = (slideIndex - index + slides.length) % slides.length;
        const active = distance === 0;
        slide.dataset.state = active ? 'active' : distance === 1 ? 'next' : 'previous';
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('inert', !active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
        }
      });

      if (manual && status) {
        const title = slides[index].querySelector('.ccc-hero-card__label > span:first-child')?.textContent.trim();
        status.textContent = `Featured design ${index + 1} of ${slides.length}${title ? `: ${title}` : ''}`;
      }
    };

    const schedule = () => {
      stop();
      updatePauseState();
      if (isPaused()) return;
      timer = setTimeout(() => {
        render(index + 1);
        schedule();
      }, 5500);
    };

    const step = (direction) => {
      render(index + direction, true);
      schedule();
    };

    previous.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    toggle.addEventListener('click', () => {
      userPaused = !userPaused;
      schedule();
    });

    showcase.addEventListener('pointerenter', () => {
      interactionPaused = true;
      schedule();
    });
    showcase.addEventListener('pointerleave', () => {
      interactionPaused = false;
      schedule();
    });
    showcase.addEventListener('focusin', () => {
      interactionPaused = true;
      schedule();
    });
    showcase.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!showcase.contains(document.activeElement)) {
          interactionPaused = false;
          schedule();
        }
      });
    });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) userPaused = true;
      schedule();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        schedule();
      }, { threshold: [0, 0.2] }).observe(showcase);
    }

    render(0);
    schedule();
  });
}
